import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Bs4ViewDate from '../../Bs4Components/Bs4ViewDate'

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch'

import * as Bs4Utils from '../../Bs4Components/Bs4Utils'

export default class Bs4Date extends Bs4GenericField {

  atrybOnchange = Bs4GenericField.CHANGE_SELF;

  setValueBs4(value) {    
    this.setValue(Bs4Utils.getValidDate(value));
  }

  getValueBs4() {    
    return Bs4Utils.toDate(this.getValue());
  }  

  getShortValue(full) {    
    return Bs4Utils.toDate(this.getValue());
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)    
    this.refFocus = React.useRef();
        
    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);

    const handleChange = (newValue) => {
      this.setValue(newValue);
    }

    const handleOpen = () => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
    }

    const handleClose = () => {
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
      this.trigger(Bs4GenericField.CHANGE_SELF, this);
    }

    const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

    return (
      <LocalizationProvider 
        adapterLocale={xx} 
        dateAdapter={AdapterDateFns}
        localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
      >        
        <Bs4ViewDate
          ref={formField.refFocus}
          readOnly={formField.readOnly}                    
          fullWidth
          label={<formField.Bs4Label/>}
          error={error}      
          hideLabel={formField.props.field.hideLabel}              
          value={value}
          ampm={false}
          onChange={handleChange}              
          timeStep={parseInt(this.props.field.min_interval) || 5} 
          onOpen={handleOpen}
          onClose={handleClose}
        />
      </LocalizationProvider>      
    );            
  }
}